export default {
  moduleList: (state) => {
    return state.app.moduleList
  },

  indexNewsList: (state) => {
    return state.app.indexNewsList
  },

  getModuleItemById: (state) => (id) => {
    return state.app.moduleList.find(m => Number(m.id) === Number(id)) || {}
  },

  getSecondModuleById: (state) => (id) => {
    let secondModuleList = []

    const targetModule = state.app.moduleList.find(m => Number(m.id) === Number(id))

    if (targetModule && Array.isArray(targetModule.children)) {
      secondModuleList = targetModule.children
    }

    return secondModuleList
  },

}